export const rewardDescription = {
    'Meu primeiro UP': {
        pt: 'Chegue ao level 2',
        en: 'Reach level 2',
        es: 'Alcanza el nivel 2',
        zh: '达到2级'
    },
    'Já não sou mais tão iniciante': {
        pt: 'Chegue ao level 10',
        en: 'Reach level 10',
        es: 'Alcanza el nivel 10',
        zh: '达到10级'
    },
    'Nada como um pescador experiente': {
        pt: 'Chegue ao level 50',
        en: 'Reach level 50',
        es: 'Alcanza el nivel 50',
        zh: '达到50级'
    },
    'A história viva de pescador': {
        pt: 'Chegue ao level 70',
        en: 'Reach level 70',
        es: 'Alcanza el nivel 70',
        zh: '达到70级'
    },
    'O verdadeiro rei dos mares': {
        pt: 'Chegue ao level 100',
        en: 'Reach level 100',
        es: 'Alcanza el nivel 100',
        zh: '达到100级'
    },
    'Meu primeiro peixe': {
        pt: 'Pegue seu primeiro peixe',
        en: 'Catch your first fish',
        es: 'Atrapa tu primer pez',
        zh: '抓到你的第一条鱼'
    },
    'Levando o peixe das crianças': {
        pt: 'Pegue 1.000 peixes',
        en: 'Catch 1,000 fish',
        es: 'Atrapa 1,000 peces',
        zh: '抓到1,000条鱼'
    },
    'Conhecido na cidade': {
        pt: 'Pegue 10.000 peixes',
        en: 'Catch 10,000 fish',
        es: 'Atrapa 10,000 peces',
        zh: '抓到10,000条鱼'
    },
    'Conhecido na região': {
        pt: 'Pegue 50.000 peixes',
        en: 'Catch 50,000 fish',
        es: 'Atrapa 50,000 peces',
        zh: '抓到50,000条鱼'
    },
    'Praticamente um showman da tv': {
        pt: 'Pegue 500.000 peixes',
        en: 'Catch 500,000 fish',
        es: 'Atrapa 500,000 peces',
        zh: '抓到500,000条鱼'
    },
    'Ajudo com o que posso': {
        pt: 'Compre 150 Paralleliums',
        en: 'Buy 150 Paralleliums',
        es: 'Compra 150 Paralleliums',
        zh: '购买150个Paralleliums'
    },
    'Amigo dos devs': {
        pt: 'Compre 1.900 Paralleliums',
        en: 'Buy 1,900 Paralleliums',
        es: 'Compra 1,900 Paralleliums',
        zh: '购买1,900个Paralleliums'
    },
    'Uma pessoa de respeito': {
        pt: 'Compre 5.500 Paralleliums',
        en: 'Buy 5,500 Paralleliums',
        es: 'Compra 5,500 Paralleliums',
        zh: '购买5,500个Paralleliums'
    },
    'Nós te amamos, sério!': {
        pt: 'Compre 11.000 Paralleliums',
        en: 'Buy 11,000 Paralleliums',
        es: 'Compra 11,000 Paralleliums',
        zh: '购买11,000个Paralleliums'
    },
    'Todos os jogadores de Fishbay te agradecem': {
        pt: 'Compre 30.000 Paralleliums',
        en: 'Buy 30,000 Paralleliums',
        es: 'Compra 30,000 Paralleliums',
        zh: '购买30,000个Paralleliums'
    },
    'Meu primeiro peixão': {
        pt: 'Pegue um peixe de 5kg ou mais',
        en: 'Catch a fish of 5kg or more',
        es: 'Atrapa un pez de 5kg o más',
        zh: '抓到一条5公斤或以上的鱼'
    },
    'História de pescador': {
        pt: 'Pegue um peixe de 10kg ou mais',
        en: 'Catch a fish of 10kg or more',
        es: 'Atrapa un pez de 10kg o más',
        zh: '抓到一条10公斤或以上的鱼'
    },
    'O homem do canal 4': {
        pt: 'Pegue um peixe de 50kg ou mais',
        en: 'Catch a fish of 50kg or more',
        es: 'Atrapa un pez de 50kg o más',
        zh: '抓到一条50公斤或以上的鱼'
    },
    'Você é a própria pescaria': {
        pt: 'Pegue um peixe de 100kg ou mais',
        en: 'Catch a fish of 100kg or more',
        es: 'Atrapa un pez de 100kg o más',
        zh: '抓到一条100公斤或以上的鱼'
    },
    'O ser mais forte da terra': {
        pt: 'Pegue um peixe de 1000kg ou mais',
        en: 'Catch a fish of 1000kg or more',
        es: 'Atrapa un pez de 1000kg o más',
        zh: '抓到一条1000公斤或以上的鱼'
    },
    'Meu primeiro dinheirinho': {
        pt: 'Tenha 1.000 moedas',
        en: 'Have 1,000 coins',
        es: 'Tener 1,000 monedas',
        zh: '拥有1,000枚硬币'
    },
    'Pobre Plus': {
        pt: 'Tenha 100.000 moedas',
        en: 'Have 100,000 coins',
        es: 'Tener 100,000 monedas',
        zh: '拥有100,000枚硬币'
    },
    'O leite das crianças tá pago': {
        pt: 'Tenha 1.000.000 moedas',
        en: 'Have 1,000,000 coins',
        es: 'Tener 1,000,000 monedas',
        zh: '拥有1,000,000枚硬币'
    },
    'Guardando para não depender do INSS': {
        pt: 'Tenha 10.000.000 moedas',
        en: 'Have 10,000,000 coins',
        es: 'Tener 10,000,000 monedas',
        zh: '拥有10,000,000枚硬币'
    },
    'O verdadeiro Magnata da pescaria': {
        pt: 'Tenha 1.000.000.000 moedas',
        en: 'Have 1,000,000,000 coins',
        es: 'Tener 1,000,000,000 monedas',
        zh: '拥有1,000,000,000枚硬币'
    }
};

export const getRewardDescription = (itemName, locale = 'pt') => {
    return rewardDescription[itemName]?.[locale] || rewardDescription[itemName]?.pt || rewardDescription.default;
};
